/**
 * WordPress Integration API Endpoints
 * Handles WordPress-related API calls. The seminar/login/update calls hit the WP
 * site directly via a bare axios (bypassing apiClient's auth interceptor).
 */
import axios, { type AxiosResponse } from "axios";
import api from "../api";
import type { QueryParams } from "../../types/api";

export const wordpressApi = {
  /** Get a WordPress auth token (via our backend). */
  getToken: (): Promise<AxiosResponse> => api.get("/api/getwptoken"),

  /** Get WordPress seminars (direct WP API call). */
  getSeminars: (token: string, params: QueryParams = {}): Promise<AxiosResponse> =>
    axios.get("https://biteg.de/wp-json/wp/v2/seminar", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  /** Get WordPress audience options (via our backend). */
  getAudiences: (): Promise<AxiosResponse> => api.get("/api/getwptoken/audiences"),

  /** Login to WordPress and get a JWT token (direct WP API call). */
  login: (username: string, password: string): Promise<AxiosResponse> =>
    axios.post("https://biteg.de/wp-json/jwt-auth/v1/token", {
      username,
      password,
    }),

  /** Update a seminar on WordPress (direct WP API call, multipart). */
  updateSeminar: (
    id: string | number,
    formdata: FormData,
    wptoken: string
  ): Promise<AxiosResponse> =>
    axios.post(`https://biteg.de/wp-json/wp/v2/seminar/${id}`, formdata, {
      headers: {
        Authorization: `Bearer ${wptoken}`,
      },
    }),
};
